import type { BaseProps, ProjectTaskAssignee } from '@/frontend/features/Fde/types'
export interface ObjectivePerson { value: string; name: string; type: string; avatar_url?: string | null }
export interface Objective {
  id: string; title: string; description: string | null; success_criteria: string
  status: 'planned' | 'in_progress' | 'paused' | 'achieved' | 'cancelled'
  due_on: string | null; result_summary: string | null; evidence: string | null
  requirements: string | null; blockers: string | null; operating_limits: string | null
  assignees: ObjectivePerson[]; participants: ObjectivePerson[]; primary_ref: string | null
  created_by_label: string; updated_by_label: string; lock_version: number
  task_count: number; completed_task_count: number
  tasks?: Array<{ id: string; identifier: string; title: string; status: string; lock_version: number }>
}
export type ObjectiveCopy = Record<string, string> & { statuses: Record<Objective['status'], string> }
export interface ObjectiveProps extends BaseProps {
  objective: Objective | null; objective_options: ProjectTaskAssignee[]; objective_copy: ObjectiveCopy
  objective_task_options: Array<{ id: string; identifier: string; title: string; lock_version: number }>
}
export const objectivePath = (projectId: string, id: string) => `/dashboard/discovery/project_objectives/${id}?project_id=${projectId}`
